import PropTypes from 'prop-types'
import { useState, useEffect, Fragment } from 'react'
import ComponenteError from '../publicaciones/ComponenteError'
import * as presupuestosService from '../servicios/presupuestosService'
import BordePrincipal from '../ui/BordePrincipal'
import Presupuesto from './Presupuesto'

const ID_AVISO_COMPRADOR = 20
const ID_AVISO_VENDEDOR = 21

const Presupuestos = ({ esVendedor }) => {
  const [presupuestos, setPresupuestos] = useState([])
  const [sinResultados, setSinResultados] = useState(false)

  useEffect(() => {
    const fetchPresupuestos = async () => {
      const idUsuario = parseInt(localStorage.getItem('idUsuario'))
      const { data } = esVendedor
        ? await presupuestosService.buscarPorVendedor(idUsuario)
        : await presupuestosService.buscarPorComprador(idUsuario)
      setPresupuestos(data)
      setSinResultados(data.length === 0)
    }
    fetchPresupuestos()
  }, [esVendedor])

  return (
    <>
      <BordePrincipal titulo="Mis Presupuestos">
        {!sinResultados ? (
          presupuestos.map((presupuesto) => (
            <Fragment key={presupuesto.idPresupuesto}>
              <Presupuesto presupuesto={presupuesto} canAdministrate={esVendedor} />
            </Fragment>
          ))
        ) : (
          <div className="row">
            <ComponenteError
              tipo="I"
              idAviso={esVendedor ? ID_AVISO_VENDEDOR : ID_AVISO_COMPRADOR}
            />
          </div>
        )}
      </BordePrincipal>
    </>
  )
}

Presupuestos.propTypes = {
  esVendedor: PropTypes.bool
}

export default Presupuestos
